import { render, staticRenderFns } from "./batchEdit.vue?vue&type=template&id=394d90fc&scoped=true"
import script from "./batchEdit.vue?vue&type=script&lang=js"
export * from "./batchEdit.vue?vue&type=script&lang=js"
import style0 from "./batchEdit.vue?vue&type=style&index=0&id=394d90fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394d90fc",
  null
  
)

export default component.exports